import React from 'react';
import { cardShell } from '../../utils/styles';

interface SectionProps {
   title?: string;
   icon?: React.ReactNode;
   children: React.ReactNode;
   className?: string;
   variant?: 'default' | 'settings';
   noPadding?: boolean;
}

const Section: React.FC<SectionProps> = ({
   title,
   icon,
   children,
   className = '',
   variant = 'default',
   noPadding = false,
}) => {
   if (variant === 'settings') {
      return (
         <div className={`${cardShell} overflow-hidden ${className}`}>
            {(title || icon) && (
               <div className="px-5 py-3 border-b border-gray-800 flex items-center gap-2">
                  {icon && <span>{icon}</span>}
                  {title && <h3 className="text-sm font-semibold text-white">{title}</h3>}
               </div>
            )}
            <div className="p-5">{children}</div>
         </div>
      );
   }
   
   return (
      <div className={`${cardShell} overflow-hidden ${noPadding ? '' : 'p-4'} ${className}`}>
         {title && (
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 px-4 pt-4">
               {title}
            </h3>
         )}
         {children}
      </div>
   );
};

export default Section;
